






























































import Vue from "vue";
import { authentication } from "@/stores";
import firebaseProject from "@/common/firebaseProject";
import { shopBase } from "@/mixins";

export default shopBase.extend(Vue).extend({
  name: "EventList",
  mixins: [],
  data(): {
    authentication: object;
    transitionName: string;
    perPage: number;
    currentPage: number;
    stateFilter: string;
    listItem: object[];
    total: number;
    listLoading: boolean;
  } {
    return {
      authentication,
      transitionName: "",
      perPage: 10,
      currentPage: 1,
      stateFilter: "",
      listItem: [],
      total: 0,
      listLoading: false
    };
  },
  async created() {
    this.callFunctions();
  },
  computed: {
    getPageCount(): number {
      return this.total ? Math.ceil(this.total / this.perPage) : 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.perPage;
      const total = this.total || 0;
      return total < count ? total : count;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
      this.callFunctions();
    },
    callFunctions() {
      this.listLoading = true;
      const functions = firebaseProject.functions("asia-northeast1");
      const callable = functions.httpsCallable("consoleEvent");
      const params = {
        shopId: this.shopId,
        parPage: this.perPage,
        currentPage: this.currentPage
      };
      callable(params)
        .then(res => {
          this.listLoading = false;
          if (res && res.data.status == "SUCCEED") {
            window.scrollTo(0, 0);
            this.listItem = res.data.event;
            this.total = res.data.maxNumber;
          }
        })
        .catch(e => {
          this.listLoading = false;
          console.error(e);
        });
    }
  }
});
